import { getType } from "@utils";
interface ServiceInfo {
  labelCode: string;
  labelMultiLangText: Record<string, string>;
  applicationCode: string;
  applicationMultiLangText: Record<string, string>;
  serviceName: string;
  serviceCode: string;
}

interface Item {
  getValue(key: string): any;
}

interface ParamObj {
  thirdType?: string;
  type?: string;
  extData?: Record<string, any>;
}

/**
 * 生成配置迁移所需参数的实例
 * @param locale
 * @param item
 * @param args
 * @param paramObj
 * @returns
 */
export function generateIntegratedData(
  locale: string | any,
  item: Item,
  args: { serviceInfo: ServiceInfo },
  paramObj: ParamObj = {}
) {
  const data = {
    labelCode: args.serviceInfo?.labelCode, // 第一级 domainCode   领域编码
    labelName: args.serviceInfo?.labelMultiLangText?.[locale], // 第一级 name  领域名称
    appCode: args.serviceInfo?.applicationCode, // 第二级 appCode   应用编码
    appName: args.serviceInfo?.applicationMultiLangText?.[locale], // 第二级 name   应用名称
    thirdName: args.serviceInfo?.serviceName, // 第三级名称  业务对象/原子服务/单据类型名称
    thirdType: paramObj.thirdType || "service", // 见下表
    thirdCode: args.serviceInfo?.serviceCode, // 第三级 serviceCode   业务对象/原子服务/单据类型编码
    domainCode: "", // 第三级 domain
    dataPk: item.getValue("id"), // 列表 tplId
    name: item.getValue('name'), // 列表 name
    type: paramObj.type || args.serviceInfo?.serviceCode || "", // 见下表
    code: item.getValue("code"),
    extData: paramObj.extData || {}, // 对接的时候确定，用户扩展的参数类
    ...paramObj
  };
  return data;
}

const KEY_SANDBOXLISTOBJ = "sandboxListObj";
/**
 * 把数据写入sessionStorage
 * @param data
 * @param rootStore
 * @returns true表示重复数据，false表示写入成功
 */
export function importSession(data: any, rootStore: any): boolean {
  let isDuplicateData = false;
  // 注入 session storage
  let objData: any[] = data;
  const { context } = rootStore;

  const tenantId: string = context?.tenantid;
  const userId: string = context?.userid;
  const baseKey = `${tenantId}-${userId}`;
  const sandboxListStr = sessionStorage.getItem(KEY_SANDBOXLISTOBJ) || "{}";
  let sandboxListObj: any;
  try {
    sandboxListObj = JSON.parse(sandboxListStr);
  } catch (error) {
    sandboxListObj = {};
  }
  if (!Array.isArray(objData)) {
    objData = [objData];
  }

  objData.forEach((obj: any) => {
    if (!sandboxListObj[baseKey]) {
      sandboxListObj[baseKey] = [obj];
    } else {
      const isObjDataExists = sandboxListObj[baseKey].find(
        (o: any) => o.dataPk === obj.dataPk && o.thirdCode === obj.thirdCode
      );

      if (!isObjDataExists) {
        sandboxListObj[baseKey].push(obj);
      } else {
        isDuplicateData = true;
      }
    }
  });

  sessionStorage.setItem(KEY_SANDBOXLISTOBJ, JSON.stringify(sandboxListObj));

  return isDuplicateData;
}
